import { OverflowTooltip } from '@backstage/core-components';

import { CustomHealthCard, ScoreWithFixAndNoFix } from '@internal/ui-common';
import { Divider, Grid, Typography, useTheme } from '@material-ui/core';
import { green, orange, red } from '@material-ui/core/colors';

interface VulnerabilitiesScoreCardProps {
  title: string;
  tooltip: string;
  deepLinkTitle: string;
  score: ScoreWithFixAndNoFix;
  link: string;
}

function VulnerabilitiesScoreCard({
  tooltip,
  deepLinkTitle,
  score,
  link,
}: Readonly<VulnerabilitiesScoreCardProps>) {
  const theme = useTheme();

  const {
    red: { fix: scoreRed },
    orange: { fix: scoreOrange },
  } = score;

  return (
    <CustomHealthCard
      title="Vulnerabilities"
      tooltip={tooltip}
      deepLink={{ title: deepLinkTitle, link: link }}
    >
      <Grid container direction="column" spacing={0}>
        <Grid
          item
          style={{ textAlign: 'center', width: '100%', paddingBottom: '2px' }}
        >
          <Typography
            variant="caption"
            style={{
              fontWeight: theme.typography.fontWeightBold,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              color: scoreRed === 0 ? green[400] : red[300],
            }}
          >
            Critical Vulnerabilities
          </Typography>
        </Grid>

        <Grid item style={{ textAlign: 'center', width: '100%' }}>
          <Typography
            variant="h3"
            style={{
              fontWeight: theme.typography.fontWeightBold,
              lineHeight: 1.1,
              color: scoreRed === 0 ? green[400] : red[300],
            }}
          >
            <OverflowTooltip
              title="Count of fixable critical vulnerabilities"
              text={scoreRed.toString()}
              line={1}
            />
          </Typography>
        </Grid>

        <Divider style={{ margin: '12px 0' }} />

        <Grid
          item
          style={{
            textAlign: 'center',
            width: '100%',
            paddingTop: '4px',
            paddingBottom: '2px',
          }}
        >
          <Typography
            variant="caption"
            style={{
              fontWeight: theme.typography.fontWeightBold,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              color: scoreOrange === 0 ? green[400] : orange[300],
            }}
          >
            High Vulnerabilities
          </Typography>
        </Grid>

        <Grid item style={{ textAlign: 'center', width: '100%' }}>
          <Typography
            variant="h3"
            style={{
              fontWeight: theme.typography.fontWeightBold,
              lineHeight: 1.1,
              color: scoreOrange === 0 ? green[400] : orange[300],
            }}
          >
            <OverflowTooltip
              title="Count of fixable high vulnerabilities"
              text={scoreOrange.toString()}
              line={1}
            />
          </Typography>
        </Grid>
      </Grid>
    </CustomHealthCard>
  );
}

export { VulnerabilitiesScoreCard };
